import findIndex from 'lodash/findIndex';

const mutations = {
  setItems(state, clients) {
    state.items = clients;
  },
  setPage(state, page) {
    state.page = page;
  },
  setPageCount(state, count) {
    state.pageCount = count;
  },
  setPerPage(state, count) {
    state.perPage = count;
  },
  setTotal(state, total) {
    state.total = total;
  },
  setHasMorePages(state, hasMorePages) {
    state.hasMorePages = hasMorePages;
  },
  setIsLoaded(state, isLoaded) {
    state.isLoaded = isLoaded;
  },
  setIsChanged(state, isChanged) {
    state.isChanged = isChanged;
  },
  setValidationError(state, response) {
    console.info(response)
    state.validationError = response;
  },
  deleteItemById(state, id) {
    let index = findIndex(state.items, {id: id});
    if (index >= 0) {
      state.items.splice(index, 1);
    }
  },
  editItem(state, item) {
    let index = findIndex(state.items, {id: item.id});
    if (index >= 0) {
      state.items.splice(index, 1, item);
    }
  },
  addItem(state, item) {
    state.items.unshift(item);
  },
  removeLastItem(state) {
    state.items.splice(-1, 1);
  },
  setTimezones(state, timezones) {
    state.timezones = timezones;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/modules/user/vuex/mutations.js